var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _circle2, _circle3, _ellipse, _rect, _path9, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path0, _path1, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path10, _polyline, _polygon, _circle4, _circle5, _circle6, _rect17, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polygon2, _path19, _polygon3, _polygon4, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect18, _polygon5, _path35, _polygon6, _rect19, _rect20, _rect21, _path36, _path37, _rect22, _path38, _path39, _path40, _path41, _ellipse2, _path42, _path43, _path44, _path45, _polygon7, _rect23, _path46, _polygon8, _rect24, _path47, _path48, _rect25, _path49, _path50;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskManagers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 534 394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#111;}.cls-2{fill:#050505;}.cls-3{fill:#4c73c0;}.cls-4{fill:#553ac7;}.cls-5{fill:#ebebff;}.cls-6{fill:#020202;}.cls-7{fill:#fff;}.cls-8{fill:#dde9ff;}.cls-9{fill:#ee7525;}.cls-10{fill:#19337c;}.cls-11{fill:#1b1b43;}.cls-12{fill:#18282e;}.cls-13{fill:#1c348c;}.cls-14{fill:#85b8e6;}.cls-15{fill:#9192ff;}.cls-16{fill:#ada8f0;}.cls-17{fill:#ffb62d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M451.87,63.05v235.38c0,4.9-3.97,8.87-8.86,8.87H100.94c-4.9,0-8.87-3.97-8.87-8.87V63.05c0-4.9,3.97-8.87,8.87-8.87h342.06c4.89,0,8.86,3.97,8.86,8.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M443,307.69H100.94c-5.11,0-9.26-4.15-9.26-9.26V63.05c0-5.11,4.15-9.26,9.26-9.26h342.06c5.1,0,9.25,4.15,9.25,9.26v235.38c0,5.11-4.15,9.26-9.25,9.26ZM100.94,54.56c-4.68,0-8.48,3.81-8.48,8.48v235.38c0,4.68,3.81,8.48,8.48,8.48h342.06c4.67,0,8.48-3.81,8.48-8.48V63.05c0-4.68-3.8-8.48-8.48-8.48H100.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M451.87,63.05v13.96H92.07v-13.96c0-4.9,3.97-8.87,8.87-8.87h342.06c4.89,0,8.86,3.97,8.86,8.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M452.25,77.4H91.68v-14.35c0-5.11,4.15-9.26,9.26-9.26h342.06c5.1,0,9.25,4.15,9.25,9.26v14.35ZM92.46,76.62h359.02v-13.58c0-4.68-3.8-8.48-8.48-8.48H100.94c-4.68,0-8.48,3.81-8.48,8.48v13.58Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.05,
    cy: 65.59,
    r: 4.13
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.79,61.46c-2.28,0-4.13,1.85-4.13,4.13s1.85,4.13,4.13,4.13,4.13-1.85,4.13-4.13-1.85-4.13-4.13-4.13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M143.53,69.72c-2.28,0-4.13-1.85-4.13-4.13s1.85-4.13,4.13-4.13,4.13,1.85,4.13,4.13-1.85,4.13-4.13,4.13ZM143.53,62.24c-1.85,0-3.35,1.5-3.35,3.35s1.5,3.35,3.35,3.35,3.35-1.5,3.35-3.35-1.5-3.35-3.35-3.35Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M245.11,70.19h-76.73c-2.53,0-4.6-2.06-4.6-4.6s2.06-4.6,4.6-4.6h76.73c2.53,0,4.6,2.06,4.6,4.6s-2.06,4.6-4.6,4.6ZM168.38,61.77c-2.11,0-3.82,1.71-3.82,3.82s1.71,3.82,3.82,3.82h76.73c2.11,0,3.82-1.71,3.82-3.82s-1.71-3.82-3.82-3.82h-76.73Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.69,186.55c0,37.06-30.04,67.11-67.11,67.11s-67.11-30.05-67.11-67.11c0-34.77,26.45-63.37,60.33-66.77l2.24,22.02c-22.7,2.28-40.42,21.45-40.42,44.75,0,24.84,20.13,44.98,44.97,44.98s44.96-20.13,44.96-44.98c0-4.33-.61-8.52-1.76-12.49l21.28-6.15c1.71,5.91,2.62,12.17,2.62,18.63Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 275.58,
    cy: 186.54,
    r: 54.19
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 275.58,
    cy: 186.54,
    r: 54.19
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 275.58,
    cy: 186.54,
    rx: 38.38,
    ry: 38.39
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 368.49,
    y: 8.26,
    width: 146,
    height: 89.27
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M514.87,97.92h-146.77V7.87h146.77v90.05ZM368.87,97.14h145.23V8.64h-145.23v88.5Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 386.87,
    y: 69.11,
    width: 8.4,
    height: 15.43
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 403.67,
    y: 62.06,
    width: 8.4,
    height: 22.48
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 420.48,
    y: 67.83,
    width: 8.4,
    height: 16.72
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 437.29,
    y: 56.06,
    width: 8.4,
    height: 28.48
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 454.09,
    y: 48.54,
    width: 8.4,
    height: 36.01
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 470.9,
    y: 37.79,
    width: 8.4,
    height: 46.75
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 487.7,
    y: 21.24,
    width: 8.4,
    height: 63.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 386.87,
    y: 28.75,
    width: 6.68,
    height: 7.56
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 403.87,
    y: 32.25,
    width: 45.23,
    height: 1.94
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M383.12,142.79l-9.25-25.54c-10.45,3.78-17.91,13.79-17.91,25.54,0,15,12.16,27.16,27.16,27.16s27.16-12.16,27.16-27.16c0-4.51-1.11-8.77-3.06-12.51l-24.1,12.51Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M410.83,120.6c-4.53-8.7-13.62-14.65-24.1-14.65-3.25,0-6.36.57-9.25,1.62l9.25,25.54,24.1-12.51Z"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 357.31,
    y: 229.83,
    width: 64.25,
    height: 61.15
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 367.37,
    y: 246.08,
    width: 36,
    height: 2.58
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 367.37,
    y: 253.82,
    width: 36,
    height: 2.58
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 120.43,
    y: 112.94,
    width: 55.87,
    height: 94.44
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 128.95,
    y: 126.61,
    width: 36.64,
    height: 33.54
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 146.88,
    y: 118.55,
    width: 0.77,
    height: 49.68,
    transform: "translate(-57.93 155.19) rotate(-47.53)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 122.43,
    y: 143,
    width: 49.68,
    height: 0.77,
    transform: "translate(-58.18 137.1) rotate(-42.48)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 19.49,
    y: 151.51,
    width: 127.79,
    height: 84.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M147.66,236.08H19.13v-84.94h128.53v84.94ZM19.86,235.34h127.05v-83.46H19.86v83.46Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "32.96 215.38 41.22 199.89 58.25 215.89 69.6 182.86 90.76 206.09 104.69 200.41 129.98 167.38"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.42 216.58 41.32 200.52 33.3 215.56 32.62 215.19 41.11 199.27 58.08 215.2 69.45 182.12 90.86 205.63 104.45 200.09 129.67 167.15 130.29 167.62 104.94 200.73 90.65 206.55 90.47 206.35 69.75 183.61 58.42 216.58"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 41.28,
    cy: 199.83,
    r: 2.13
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 58.12,
    cy: 215.51,
    r: 2.13
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 69.73,
    cy: 182.99,
    r: 2.13
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 164.93,
    width: 54.19,
    height: 0.77
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M323.01,358.67c.98-15.15,7.44-29.89,17.92-40.89,10.48-10.99,24.89-18.15,39.98-19.86-9.17,3.82-16,11.75-21.38,20.09-5.38,8.35-9.7,17.41-15.8,25.24-6.1,7.84-14.48,14.58-24.33,15.85l3.61-.44Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M319.4,359.21c-.05,0-.1-.04-.1-.09,0-.06.03-.11.09-.12,1.09-.14,2.28-.36,3.55-.71.52-7.43,2.33-14.72,5.38-21.67,3.1-7.07,7.32-13.43,12.54-18.91,5.22-5.48,11.38-10,18.29-13.43,6.91-3.43,14.23-5.61,21.75-6.46.05,0,.1.03.11.08.01.05-.01.1-.06.12-7.73,3.22-14.71,9.78-21.33,20.05-2,3.1-3.89,6.36-5.71,9.51-3.08,5.32-6.26,10.82-10.1,15.74-3.31,4.25-6.94,7.75-10.78,10.41-3.22,2.22-6.54,3.8-9.9,4.73,0,.07,0,.14-.01.22,0,.05-.04.09-.09.1l-3.61.44s0,0-.01,0ZM323.01,358.67h0,0ZM322.92,358.52c-.14.04-.27.07-.41.11l.41-.05s0-.04,0-.06ZM380.2,298.11c-7.24.9-14.29,3.04-20.96,6.35-6.89,3.42-13.03,7.93-18.23,13.39s-9.41,11.8-12.5,18.85c-3.03,6.91-4.83,14.15-5.36,21.53,5.77-1.6,13.16-5.61,20.5-15.04,3.83-4.92,7.01-10.41,10.08-15.72,1.82-3.15,3.71-6.41,5.71-9.52,6.46-10.02,13.25-16.52,20.76-19.85Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M320.79,358.31c3.4-17.02,3.82-34.62,1.23-51.78-.92-6.09-2.27-12.27-5.53-17.5-3.26-5.23-8.75-9.41-14.9-9.66,6.17,7.14,7.99,17.07,8.18,26.5.18,9.44-1.03,18.92.09,28.29,1.12,9.37,5.07,19.03,13.07,24.05l-2.13.1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M320.79,358.42s-.06-.01-.08-.04c-.02-.02-.03-.06-.02-.09.09-.45.18-.89.26-1.34-2.91-2.28-5.34-5.33-7.23-9.09-2-3.96-3.37-8.69-3.97-13.69-.7-5.87-.49-11.88-.28-17.68.12-3.48.25-7.08.19-10.61-.23-11.7-2.9-20.35-8.15-26.44-.03-.03-.03-.08-.02-.11s.06-.06.1-.06c5.66.23,11.4,3.95,14.99,9.71,3.37,5.41,4.69,11.9,5.55,17.54,2.54,16.77,2.22,33.7-.94,50.35.58.45,1.18.87,1.79,1.26.04.02.06.07.05.12-.01.04-.05.08-.1.08l-2.13.1s0,0,0,0ZM321.14,357.1c-.07.37-.14.73-.21,1.1l1.66-.08c-.49-.32-.98-.66-1.45-1.02ZM301.82,279.49c5.19,6.12,7.82,14.75,8.04,26.38.07,3.54-.06,7.14-.19,10.62-.21,5.8-.42,11.8.28,17.65,1.17,9.8,5.15,17.87,11.04,22.57,3.14-16.59,3.45-33.46.92-50.17-.85-5.62-2.17-12.08-5.52-17.46-3.5-5.62-9.06-9.28-14.57-9.6Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M319.39,359.17c-1.72-12.29-3.75-24.94-10.34-35.46-6.58-10.52-18.94-18.42-31.11-16.02,8.55,4.02,15.65,11.04,19.76,19.54,3.02,6.24,4.45,13.16,7.61,19.32,3.16,6.17,8.8,11.81,15.72,12.03l-1.65.59Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M319.39,359.27s-.04,0-.05-.02c-.03-.02-.05-.04-.05-.08-.03-.23-.06-.46-.1-.69-5.45-.94-10.57-5.26-13.97-11.9-1.65-3.22-2.85-6.7-4.01-10.07-1.06-3.08-2.16-6.27-3.6-9.25-4.13-8.54-11.13-15.46-19.71-19.49-.04-.02-.07-.06-.06-.11s.04-.08.08-.09c5.76-1.13,11.88-.04,17.72,3.18,5.34,2.94,10.13,7.52,13.5,12.89,6.27,10.01,8.38,21.63,10.23,34.66.55.09,1.11.14,1.67.16.05,0,.09.04.1.09,0,.05-.02.1-.07.12l-1.65.59s-.02,0-.04,0ZM319.41,358.53c.02.17.05.33.07.5l1.03-.37c-.37-.03-.74-.07-1.1-.13ZM278.28,307.73c8.49,4.07,15.42,10.97,19.52,19.45,1.45,2.99,2.55,6.19,3.61,9.28,1.16,3.36,2.35,6.84,3.99,10.04,3.35,6.54,8.39,10.82,13.75,11.77-1.84-12.98-3.96-24.55-10.19-34.51-3.34-5.34-8.11-9.9-13.42-12.82-5.69-3.13-11.65-4.24-17.26-3.22Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M318.21,358.1c1.01-12.85,2.06-25.9,6.62-37.95,4.56-12.06,13.18-23.2,25.24-27.74-7.1,4.44-10.95,12.69-12.75,20.87-1.8,8.18-1.92,16.65-3.58,24.86-1.66,8.21-5.19,16.54-12.04,21.35l-3.48-1.39Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M321.69,359.59s-.03,0-.04,0l-3.48-1.39s-.07-.06-.07-.11c1-12.69,2.03-25.82,6.63-37.98,5.12-13.54,14.34-23.67,25.3-27.8.05-.02.11,0,.13.05.02.05,0,.11-.04.14-4.3,2.69-10,8.49-12.71,20.81-.94,4.27-1.43,8.69-1.9,12.97-.43,3.92-.88,7.96-1.68,11.89-1.39,6.88-4.61,16.17-12.09,21.42-.02.01-.04.02-.06.02ZM318.32,358.03l3.35,1.34c7.39-5.21,10.58-14.43,11.96-21.26.79-3.92,1.24-7.96,1.67-11.87.47-4.28.97-8.71,1.91-12.99,2.55-11.6,7.74-17.45,11.95-20.38-10.49,4.32-19.29,14.22-24.24,27.31-4.58,12.11-5.61,25.19-6.61,37.85Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "345.52 385.74 299.02 385.74 291.85 349.97 352.69 349.97 345.52 385.74"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M345.61,385.85h-46.68l-.02-.08-7.2-35.9h61.1l-7.21,35.98ZM299.11,385.64h46.33l7.13-35.56h-60.58l7.13,35.56Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "428.78 364.23 428.78 385.74 400.88 385.74 413.65 375.32 414.32 362.22 428.78 364.23"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "461.38 365.24 462.39 385.74 434.49 385.74 446.26 375.66 446.26 363.22 461.38 365.24"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413,246.25l19.4-12.72-.73,12.03,1.39,37.07-7.35,33.42,7.11,50.73h-23.51l-7.47-38.64c-2.21-11.44-2.03-23.21.52-34.58l10.64-47.31"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M432.95,366.89h-23.72l-.02-.09-7.47-38.64c-2.23-11.52-2.05-23.17.52-34.62l10.65-47.35.04-.02,19.58-12.84-.74,12.24,1.39,37.08h0s-7.35,33.41-7.35,33.41l7.13,50.83ZM409.4,366.67h23.3l-7.1-50.62v-.02s7.35-33.41,7.35-33.41l-1.38-37.06.72-11.83-19.19,12.58-10.63,47.26c-2.57,11.42-2.74,23.04-.52,34.54l7.46,38.55Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M431.59,240.58c.48,42.86,4.03,85.05,10.83,126.51h23.51c-4.89-31.71-7.1-70.21-4.37-121.26l-16.98-13.9-12.99,8.66Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M466.04,367.19h-23.72v-.09c-6.72-40.91-10.36-83.48-10.84-126.52v-.06s13.1-8.74,13.1-8.74l17.08,13.99v.05c-2.49,46.42-1.06,86.07,4.36,121.24l.02.12ZM442.5,366.98h23.29c-5.41-35.14-6.83-74.76-4.35-121.11l-16.87-13.82-12.88,8.59c.48,42.98,4.12,85.49,10.81,126.35Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M418.68,244.47s4.25,34.62,7.17,37.3,15.43,0,15.43,0l7.48-41.91-30.08,4.62Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M484.17,139.66l1.26-3s-4.65-9.79-3.2-11.05c1.45-1.26,3.77,2.32,3.77,2.32,0,0-.68-11.61,1.55-11.71,1.88-.08,1.74,3.29,1.94,8.32,0,0,1.16-1.55,3.3.05.96-1.6,2.99-.54,3.57.43.68-.77,3.48-.58,3.1,2.71-.49,4.17-2.7,12.27-2.7,12.27l-5.91,4.76-6.67-5.11Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M490.84,144.91l-6.8-5.21,1.27-3.03c-.16-.34-1.23-2.63-2.13-5.02-1.32-3.5-1.66-5.56-1.02-6.11.27-.24.59-.33.95-.28,1.1.16,2.29,1.65,2.77,2.32-.09-1.82-.37-9.54,1.08-11.14.18-.2.38-.3.59-.31.36-.02.67.09.92.32.89.82.96,3.18,1.07,6.44.01.46.03.93.05,1.42.41-.37,1.51-1.04,3.17.15.34-.51.83-.78,1.41-.78h0c.87,0,1.79.6,2.21,1.19.39-.32,1.17-.46,1.9-.13,1.4.62,1.36,2.32,1.28,3.02-.49,4.13-2.68,12.2-2.7,12.28v.03s-6.01,4.84-6.01,4.84ZM484.3,139.63l6.54,5.01,5.82-4.69c.15-.57,2.22-8.24,2.69-12.22.22-1.89-.63-2.57-1.16-2.8-.69-.31-1.46-.16-1.76.18l-.1.11-.07-.12c-.35-.58-1.25-1.2-2.1-1.2h0c-.55,0-.99.26-1.3.77l-.06.1-.09-.07c-2.02-1.51-3.1-.13-3.15-.07l-.18.24v-.29c-.03-.58-.05-1.13-.07-1.67-.1-3.21-.18-5.53-1-6.29-.21-.19-.46-.28-.77-.27-.16,0-.31.09-.45.24-1.55,1.71-1.01,11.26-1,11.36l.02.4-.22-.33s-1.54-2.35-2.83-2.53c-.3-.04-.56.03-.78.23-1.14.99,1.94,8.22,3.22,10.92l.02.04-1.24,2.97Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M378.46,205.27c-.79-.7-1.79-1.13-2.85-1.22-5.37-.45-22.14-1.74-21.98-.44.19,1.55,12.97,7.35,12.97,7.35,2.73,3.07,5.83,6.32,8.57,9.39l7.21-11.39-3.92-3.7Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M375.17,220.53l-.09-.1c-1.37-1.54-2.85-3.14-4.28-4.7-1.43-1.55-2.91-3.15-4.28-4.69-1.03-.42-12.81-5.88-13-7.42,0-.06,0-.14.08-.22.17-.18.7-.73,9.49-.31,4.68.22,9.85.63,12.52.85,1.09.09,2.09.52,2.91,1.25h0s3.98,3.76,3.98,3.76l-7.33,11.58ZM357.62,203.15c-2.16,0-3.6.12-3.86.4-.03.03-.02.04-.02.05.15,1.23,9.61,5.78,12.91,7.27l.04.03c1.36,1.54,2.85,3.14,4.28,4.69,1.4,1.52,2.85,3.09,4.19,4.59l7.09-11.2-3.85-3.64c-.78-.69-1.75-1.11-2.78-1.19-6.65-.55-13.73-1-17.98-1Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M484.07,139.45l-10.9,25.09s-12.9,13.42-29.42,14.89l-9.42.07-4.97,2.11.13-.26-14.44,2.52c-3.46.6-6.43,2.8-8.02,5.93l-14.31,28.12-10.43-9.25-7.51,11.51c.91,1.03,1.83,2.06,2.74,3.08,4.05,4.56,8.78,10.69,15.11,12.02,3.23.68,6.23-.66,8.54-2.88,1.69-1.63,3.21-3.64,4.42-5.65l4.72-7.78,2.69,27.28,48.55-.43-1.42-46.24,22.53-19.55c3.3-2.87,5.66-6.67,6.75-10.91l7.61-29.49-12.97-.19Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M412.91,246.36l-2.67-27.06-4.55,7.51c-1.31,2.18-2.84,4.14-4.44,5.67-2.6,2.5-5.67,3.53-8.63,2.91-5.69-1.19-10.02-6.16-13.84-10.54-.45-.52-.89-1.02-1.33-1.51l-2.79-3.14,7.62-11.68,10.42,9.24,14.25-28c1.6-3.14,4.63-5.38,8.1-5.99l14.65-2.56-.1.19,4.75-2,9.42-.07c16.05-1.43,28.85-14.35,29.33-14.85l10.92-25.14,13.17.2-7.64,29.62c-1.1,4.28-3.45,8.07-6.79,10.96l-22.5,19.51,1.42,46.29h-.11s-48.65.43-48.65.43ZM410.38,218.65l2.72,27.49,48.35-.43-1.42-46.18.04-.03,22.53-19.55c3.3-2.87,5.63-6.62,6.72-10.85l7.58-29.36-12.76-.19-10.88,25.05h-.01c-.13.15-13.12,13.48-29.49,14.94l-9.4.07-5.22,2.21.17-.33-14.23,2.49c-3.41.6-6.38,2.79-7.95,5.87l-14.37,28.24-10.44-9.26-7.39,11.34,2.69,3.02c.43.49.88,1,1.33,1.51,3.8,4.36,8.11,9.3,13.72,10.47,2.89.61,5.89-.41,8.44-2.85,1.58-1.52,3.1-3.46,4.4-5.63l4.88-8.05Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M430.24,190.53c-4.13.33-7.73-2.74-8.07-6.86l-.09-1.05-1.18-14.6,9.1-.73,5.84-.47,1.25,15.64c.33,4.13-2.74,7.73-6.86,8.07Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M429.63,190.66c-3.91,0-7.24-3.01-7.56-6.98l-.09-1.04-1.19-14.7,15.14-1.22,1.26,15.74c.34,4.17-2.78,7.84-6.96,8.18h0c-.21.02-.41.02-.62.02ZM421.02,168.12l1.25,15.54c.33,4.06,3.9,7.09,7.95,6.76,4.06-.33,7.09-3.9,6.76-7.95l-1.25-15.53-5.73.46-8.99.72Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M436.24,163.05l-.67,5.57c-.37,3.14-2.27,5.92-5.11,7.35-2.6,1.32-6.17,2.53-10.38,2.4-3.25-.1-5.16-3.14-6.27-7.01-.46-1.62-.78-3.38-1.01-5.13-.18-1.38-.29-2.75-.37-4.05-.25-4.32,2.45-8.28,6.6-9.65l2.7-.89c2.79-.92,5.85-.53,8.32,1.06l1.84,1.19c3.09,1.99,4.77,5.54,4.33,9.16Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M420.71,178.49c-.21,0-.42,0-.63,0-2.89-.09-5.04-2.47-6.37-7.09-.43-1.49-.77-3.22-1.01-5.15-.16-1.27-.29-2.63-.37-4.06-.25-4.36,2.49-8.37,6.67-9.75l2.7-.89c2.84-.94,5.9-.55,8.41,1.07l1.84,1.19c3.14,2.02,4.82,5.57,4.38,9.26h-.1s.1,0,.1,0l-.67,5.57c-.38,3.21-2.31,5.99-5.17,7.44-3.18,1.61-6.47,2.42-9.8,2.42ZM424.81,151.26c-1.02,0-2.04.16-3.03.49l-2.7.89c-4.09,1.35-6.77,5.27-6.53,9.54.08,1.42.2,2.78.37,4.04.25,1.91.59,3.63,1.01,5.12,1.3,4.52,3.38,6.86,6.17,6.94,3.51.11,6.98-.7,10.32-2.39,2.79-1.41,4.68-4.13,5.05-7.27l.67-5.57c.43-3.61-1.21-7.08-4.29-9.06l-1.84-1.19c-1.58-1.01-3.38-1.53-5.2-1.53Z"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 161.02,
    y: 258.85,
    width: 53.85,
    height: 3.62
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "214.87 258.86 169.4 258.86 186.62 216.86 232.1 216.86 214.87 258.86"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.13,259.24h-46.32l17.54-42.77h46.32l-17.54,42.77ZM169.97,258.47h44.64l16.91-41.22h-44.64l-16.91,41.22Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "210.95 255.33 175.21 255.33 188.74 222.32 224.48 222.32 210.95 255.33"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 195.99,
    y: 263.64,
    width: 0.77,
    height: 122.3
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 152.95,
    y: 262.48,
    width: 86.87,
    height: 6.91
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 82.07,
    y: 315.01,
    width: 0.77,
    height: 70.93
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M103.7,318.3h-42.49c.9-4.31,4.71-7.4,9.11-7.4h24.27c4.41,0,8.21,3.09,9.11,7.4h0Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M76.09,380.88h12.73c2.58,0,4.67,2.09,4.67,4.67v.19h-22.06v-.19c0-2.58,2.09-4.67,4.67-4.67Z"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.15,
    y: 213.08,
    width: 14.22,
    height: 20.84
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M108.47,234.03h-14.43v-21.05h14.43v21.05ZM94.25,233.81h14.01v-20.63h-14.01v20.63Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M116.36,211.04c-.44,7.2-3.21,15.34-10.77,13.33-5.94-1.58-12.47-6.58-12.47-13.79s4.99-13.06,11.15-13.06c3.85,0,8.69,1.87,10.97,5.48,1.37,2.16,1.31,4.9,1.12,8.04Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M107.81,224.79c-.71,0-1.47-.1-2.25-.31-6.04-1.61-12.55-6.64-12.55-13.89s5.05-13.16,11.25-13.16c3.65,0,8.66,1.73,11.06,5.52,1.38,2.18,1.33,4.96,1.14,8.1h-.11s.11,0,.11,0c-.17,2.84-1,9.74-4.9,12.55-1.1.79-2.36,1.19-3.76,1.19ZM104.27,197.63c-6.09,0-11.04,5.81-11.04,12.95,0,5.01,3.88,11.42,12.39,13.69,2.26.6,4.22.31,5.83-.85,3.82-2.76,4.64-9.58,4.81-12.39h0c.19-3.11.24-5.85-1.1-7.98-2.36-3.73-7.29-5.43-10.89-5.43Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M103.77,208.95c.9-2.11,2.07-3.47,3.18-4.33,1.55-1.22,3.75-1.1,5.24.2,2.81,2.46,7.95,5.83,8.21-2.08.22-6.67-4.77-7.53-7.27-7.8-1.05-.11-2.04-.53-2.82-1.25-4.13-3.82-9.88-1.81-12.1,1.05-2.42,3.12-1.56,1.33-7.26,3.36-5.7,2.03-2.07,9.29-3.67,11.32-5.19,2.46-5.3,11.61-2.45,14.93,3.06,3.56,7.35,2.46,10.41.9,2.3-1.17,4.05-3.18,4.94-5.6l3.59-10.69Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 96.35,
    cy: 192.45,
    rx: 6.02,
    ry: 6.53,
    transform: "translate(-9 4.78) rotate(-2.71)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M162.49,252.66l12.05-3.54c.87-.26,1.8-.12,2.56.39,3.3,2.19,12.08,8.39,9.86,10.92-1.11,1.27-11.19-1.7-11.19-1.7l-14.59,4.07,1.3-10.14Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M161.06,262.94l1.33-10.36,12.12-3.56c.9-.26,1.86-.12,2.64.4,2.95,1.96,9.85,6.83,10.25,9.79.07.5-.05.94-.36,1.29-1.12,1.28-10.55-1.45-11.27-1.66l-14.72,4.11ZM162.59,252.74l-1.28,9.91,14.47-4.04h.03c2.79.83,10.21,2.74,11.08,1.74.27-.31.37-.68.31-1.12-.38-2.87-7.23-7.7-10.16-9.64-.73-.48-1.63-.62-2.47-.37l-11.99,3.52Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M162.49,252.66l-24.51,4.64-14.95-16.46c-2.72-2.99-6.05-5.38-9.76-6.99-.16-.09-.33-.17-.5-.24l-15.52-6.9c-2.51-.98-5.3-.91-7.75.2-2.93,1.33-5.04,4.02-5.64,7.18l-8.58,45.26,45.54,5.81-.75-12.63-.53-8.88,8.79,9.56c1.67,1.82,4.16,2.66,6.59,2.22l30.8-9.63-3.23-13.16Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M120.93,285.3l-45.78-5.84,8.61-45.37c.61-3.2,2.74-5.92,5.7-7.26,2.45-1.12,5.31-1.19,7.83-.2l15.53,6.9c.16.07.32.15.51.25,3.74,1.62,7.04,3.98,9.79,7.01l14.91,16.42,24.55-4.65.02.1,3.25,13.26-.09.03-30.8,9.63c-2.49.45-4.99-.4-6.7-2.25l-8.59-9.34,1.27,21.35ZM75.4,279.28l45.3,5.78-1.29-21.68,8.99,9.78c1.66,1.8,4.08,2.62,6.49,2.19l30.69-9.59-3.18-12.97-24.47,4.64-.04-.04-14.95-16.46c-2.73-3-6-5.34-9.72-6.96-.19-.1-.35-.17-.5-.24l-15.52-6.9c-2.47-.97-5.26-.89-7.66.2-2.9,1.32-4.99,3.97-5.58,7.11l-8.56,45.15Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.17 353.64 109.35 372.77 134.16 385.51 127.56 370.41 132.95 358.44 119.17 353.64"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 120.36,
    y: 371.06,
    width: 7.35,
    height: 0.77,
    transform: "translate(-99.84 50.14) rotate(-16.4)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M134.62,366.21l-22.48-8.39,15.4-47.91c2.65-7.09,10.8-10.6,18.21-7.84h0c7.41,2.76,11.27,10.76,8.62,17.85l-19.75,46.28Z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.43 362.97 158.62 385.74 186.52 385.74 173.75 375.32 170.75 362.2 156.43 362.97"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 166.67,
    y: 376.76,
    width: 7.55,
    height: 0.77,
    transform: "translate(-160.9 129.15) rotate(-28.87)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M176.56,365.68l-24.38,3.87-16.7-49.1-3.04-8.96-41.47.33c-10.26.23-18.42-8.55-17.41-18.77l1.73-13.69,41.03,5.16,26.96,2.96c11.22,1.94,14.67,8.73,17.01,17.46l16.28,60.72Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M135.47,320.45l-3.04-8.96,5.61-.19c.52,3.38-.82,7.14-2.57,9.15Z"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 35.67,
    y: 385.36,
    width: 469.88,
    height: 0.77
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M409.28,206.15c1.02,9.63,2,20.35,2.75,30.02-1.02-9.64-2.01-20.36-2.75-30.02h0Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M441.29,155.1c0-1.44-.62-2.74-1.6-3.65-.04-.13-.08-.26-.13-.39.11-.42.18-.85.18-1.31,0-2.61-2-4.74-4.56-4.96-.78-1.73-2.52-2.94-4.54-2.94-.52,0-1.01.08-1.48.22-.9-.89-2.14-1.44-3.5-1.44-1.27,0-2.42.48-3.3,1.26-1.57.2-2.9,1.12-3.67,2.42-.86.1-1.65.42-2.31.9-.63-.29-1.33-.46-2.07-.46-2.75,0-4.98,2.23-4.98,4.98,0,.33.03.66.1.98-.95,1.06-1.54,2.11-1.66,3.07-.02,6.56,8.52,8.66,19.1,2.92,2.34-1.34,4.76,1.08,6.96,6.36.03.08.07.15.11.23l1.9,3.52c1.82-2.5,3.24-5.29,3.92-8.14.94-.91,1.53-2.18,1.53-3.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskManagers);
export default __webpack_public_path__ + "static/media/risk-managers.2fe35996d4c273eb1c5ba190af77a04d.svg";
export { ForwardRef as ReactComponent };